export const getPageNumbers = ({ currentPage, pageSize, total, pageNumbersToShow }) => {
	const totalPages = Math.ceil(total / pageSize);
	const pages = [];
	const halfPageNumbersToShow = Math.floor(pageNumbersToShow / 2);

	//! Ensure currentPage is within bounds
	const clampedCurrentPage = Math.min(Math.max(currentPage, 1), totalPages);

	//! Always show first page
	pages.push(1);

	//! Determine start and end page numbers for the pagination
	let startPage = Math.max(clampedCurrentPage - halfPageNumbersToShow, 2);
	let endPage = Math.min(clampedCurrentPage + halfPageNumbersToShow, totalPages - 1);

	//! Adjust if we're too close to the start or end
	if (clampedCurrentPage - halfPageNumbersToShow <= 1) {
		endPage = Math.min(endPage + (halfPageNumbersToShow - clampedCurrentPage + 1), totalPages - 1);
	}

	if (clampedCurrentPage + halfPageNumbersToShow >= totalPages) {
		startPage = Math.max(startPage - (clampedCurrentPage + halfPageNumbersToShow - totalPages), 2);
	}

	//! Add start pages and dots
	if (startPage > 3) {
		pages.push('...');
	}

	//! Add middle pages
	for (let i = startPage; i <= endPage; i++) {
		pages.push(i);
	}

	//! Add end pages and dots
	if (endPage < totalPages - 1) {
		pages.push('...');
	}

	//! Always show last page
	if (totalPages > 1) {
		pages.push(totalPages);
	}

	return pages;
};
